module.exports = __webpack_public_path__ + "img/logo_mediaindonesia.d0130d78.png";